import { RateCurrency } from 'shared/price-utilities'
import styles from './styles.module.scss'

export const PriceToPay = ({ rate, total, label, rowStyles }) => (
    <div className={rowStyles}>
        <span className="mr-1">{label}</span>
        <h2 className={styles.totalPrice}>
            <RateCurrency id="booking-price-to-pay" rate={rate} value={total} />
        </h2>
    </div>
)
